import { createRouter, createWebHashHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import WorkspaceView from '../views/WorkspaceView.vue'
import ProjectView from '../views/ProjectView.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { title: '个人中心' }
  },
  {
    path: '/workspace/:projectId',
    name: 'workspace',
    component: WorkspaceView,
    props: true,
    meta: { title: '项目工作区' }
  },
  {
    path: '/project/:projectId',
    name: 'project',
    component: ProjectView,
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  if (to.meta?.title) {
    document.title = `${to.meta.title} - AI漫剧生成器`
  }
  next()
})

export default router
